<template>
  <el-row class="container">
    <el-col :span="24" class="header">
     <el-col
        :span="20"
        :xs="12"
        class="logo"
        :class="collapsed?'logo-collapse-width':'logo-width'" 
      >
      <img src="../assets/sllogo.png" class="logoImg" v-if="!collapsed" @click="goHome()" /> 
      <span @click="goHome()">小森林</span>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <span @click="$router.push('/table')">{{collapsed?'':sysName}}</span>
    </el-col>
      <!--<el-col :span="10" class="middle">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>-->
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">
            <!--<img src="../assets/user.jpg">-->
            {{uName}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>-->
            <!-- 退出登录 -->
            <el-dropdown-item @click.native="cpwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu
          :default-active="$route.path"
          :class="[!collapsed?'expanded':'', 'el-menu-vertical-demo']"
          @open="handleopen"
          @close="handleclose"
          @select="handleselect"
          unique-opened
          router
          v-show="!collapsed"
        >
          <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
            <el-submenu :index="index+''" v-if="!item.leaf">
              <template slot="title">
                <i :class="item.iconCls"></i>
                {{item.name}}
              </template>
              <el-menu-item
                v-for="child in item.children"
                :index="child.path"
                :key="child.path"
                v-if="!child.hidden"
              >{{child.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>
              {{item.children[0].name}}
            </el-menu-item>
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
          <li
            v-for="(item,index) in $router.options.routes"
            v-if="!item.hidden"
            class="el-submenu item"
          >
            <template v-if="!item.leaf">
              <div
                class="el-submenu__title"
                style="padding-left: 20px;"
                @mouseover="showMenu(index,true)"
                @mouseout="showMenu(index,false)"
              >
                <i :class="item.iconCls"></i>
              </div>
              <ul
                class="el-menu submenu"
                :class="'submenu-hook-'+index"
                @mouseover="showMenu(index,true)"
                @mouseout="showMenu(index,false)"
              >
                <li
                  v-for="child in item.children"
                  v-if="!child.hidden"
                  :key="child.path"
                  class="el-menu-item"
                  style="padding-left: 40px;"
                  :class="$route.path==child.path?'is-active':''"
                  @click="$router.push(child.path)"
                >{{child.name}}</li>
              </ul>
            </template>
            <template v-else>
              <li class="el-submenu">
                <div
                  class="el-submenu__title el-menu-item"
                  style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                  :class="$route.path==item.children[0].path?'is-active':''"
                  @click="$router.push(item.children[0].path)"
                >
                  <i :class="item.iconCls"></i>
                </div>
              </li>
            </template>
          </li>
        </ul>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="breadcrumb-container">
            <strong class="title">{{$route.name}}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">{{ item.name }}</el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>


        <el-dialog title="修改密码" :visible.sync="updatePwd2" width="400px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="请输入原密码" label-width="120px" prop="old_password">
          <el-input style="width:200px" v-model="form.old_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码" label-width="120px" prop="new_password">
          <el-input style="width:200px" v-model="form.new_password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" label-width="120px" prop="checkPass">
          <el-input style="width:200px" v-model="form.checkPass" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePwd2 = false">取 消</el-button>
        <el-button type="primary" @click="changePwd">确 定</el-button>
      </div>
    </el-dialog>

  </el-row>
</template>

<script>
import { updatePwd,scpwd,sconfig } from "../api/api";

export default {
  data() {
    var nPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("新密码不能为空!"));
      } else if (value.length<6) {
        callback(new Error("密码长度不能低于6位"));
      } else {
        callback();
      }
    };
    var vPass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== this.form.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
            rules: {
        old_password: [
          { required: true, message: "原密码不能为空", trigger: "change" }
        ],
        new_password: [
          { required: true,validator:nPass, trigger: "blur" }
        ],
        checkPass: [{ validator: vPass,required: true, trigger: "blur" }]
      },
      screenWidth: document.body.clientWidth,
      sysName: "用户管理",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      uName:'',
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      dialogTableVisible:false,

      updatePwd2: false,
      form:{
        old_password:'',
        new_password:'',
      },


    };
  },
    created() {
    let that = this;
    document.onkeydown = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13&&that.updatePwd2) {
        that.changePwd();
         return false;
      }
    };
  },

  methods: {
  	goHome(){
  		window.location.href='https://home.yxcg.net/'
  	},
    cpwd(){
      this.form={old_password: "", new_password: ""};
      this.updatePwd2=true;
    },
    changePwd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          scpwd(this.form, this.$cookie.getCookie("login")).then(res => {
            if(res.code==200){
              this.updatePwd2=false;
              this.$router.push({path:'/login'})
            }else{
              this.$message.error(res.msg);
            }
          });
        }
      });
    },


    onSubmit() {
      console.log("submit!");
    },
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function(a, b) {},
    //退出登录
    logout: function() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          // sessionStorage.removeItem("user");
          _this.$router.push("/login");
        })
        .catch(() => {});
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
  },
  mounted() {
    //获取配置文件
    sconfig(this.$cookie.getCookie("login")).then(res => {
      if (res.code == 200) {
        this.$store.config = res.data;
      }
    });
    var that = this;
    if (this.$cookie.getCookie("user")) {
      this.uName = decodeURIComponent(this.$cookie.getCookie("user"));
      this.uPwd = this.$cookie.getCookie("pwd");
      this.form.old_password=this.uPwd;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~scss_vars";

.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    border-bottom:1px solid #e6e6e6;
    /*background: $color-primary;*/
    color: #333333;
    .userinfo {
      // background: $color-primary;
      // line-height: 0;
      height: 60px;
      text-align: right;
      padding-right: 35px;
      box-sizing: border-box;
      float: right;
      .userinfo-inner {
        cursor: pointer;
        color: #333333;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 10px 0px 10px;
          float: left;
        }
      }
    }
    .logo {
      /*width:230px;*/
      /*background: $linear;*/
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
      border-color: rgba(238, 241, 146, 0.3);
      border-right-width: 1px;
      border-right-style: solid;
      transition: all 0.3s;
      color:#333333;
      img {
        width: 40px;
      	height: 40px;
      	display: inline-block;
      	vertical-align: middle;
      	margin: 0 5px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      /*width: 230px;*/
    }
    .logo-collapse-width {
      padding: 0;
      width: 0px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    // background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0px;
    overflow: hidden;
    aside {
      flex: 0 0 230px;
      width: 230px;

      .el-menu {
        height: 100%;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
      .expanded {
        width: 170px !important;
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
      transition: all 0.5s;
    }
    .menu-expanded {
      flex: 0 0 170px;
      width: 170px;
    }
    .content-container {
      // background: #f1f2f7;
      flex: 1;
      // position: absolute;
      // right: 0px;
      // top: 0px;
      // bottom: 0px;
      // left: 230px;
      overflow-y: scroll;
      padding: 30px;
      .breadcrumb-container {
        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// Home.vue?0dd8e0ca